// Copyright (c) 2025 Nebularis Holdings LLC
// Licensed to Nutrx Solutions under a non-exclusive, non-transferable license.
// See IP License Agreement for usage restrictions.

// frontend/src/components/enterprise-admin/organization/ComplianceContactsSection.jsx

import React from "react";
import {
  Field,
  TextInput,
} from "../../../design-system/components";
import OrganizationSectionCard from "./OrganizationSectionCard";

function ContactFields({ prefix, title, draft, setField }) {
  return (
    <div className="enterprise-admin-contact-block">
      <h4>{title}</h4>

      <Field label="Name">
        <TextInput
          value={draft[`${prefix}_name`] || ""}
          onChange={(event) =>
            setField(`${prefix}_name`, event.target.value)
          }
          placeholder="Full name"
          autoComplete="name"
        />
      </Field>

      <Field label="Title">
        <TextInput
          value={draft[`${prefix}_title`] || ""}
          onChange={(event) =>
            setField(`${prefix}_title`, event.target.value)
          }
          placeholder="Role or title"
          autoComplete="organization-title"
        />
      </Field>

      <Field label="Email">
        <TextInput
          type="email"
          value={draft[`${prefix}_email`] || ""}
          onChange={(event) =>
            setField(`${prefix}_email`, event.target.value)
          }
          placeholder="name@company.com"
          autoComplete="email"
        />
      </Field>
    </div>
  );
}

export default function ComplianceContactsSection({ draft, setField }) {
  return (
    <OrganizationSectionCard
      eyebrow="Compliance contacts"
      title="Accountable enterprise contacts"
      description="Identify the people responsible for organization administration and compliance ownership."
    >
      <div className="enterprise-admin-contact-grid">
        <ContactFields
          prefix="primary_contact"
          title="Primary contact"
          draft={draft}
          setField={setField}
        />
        <ContactFields
          prefix="compliance_owner"
          title="Compliance owner"
          draft={draft}
          setField={setField}
        />
      </div>
    </OrganizationSectionCard>
  );
}
